import createReactComponent from '../createReactComponent';
var Voicemail = createReactComponent('Voicemail', [['circle', {
  cx: '5.5',
  cy: '11.5',
  r: '4.5',
  key: 'uvt47c'
}], ['circle', {
  cx: '18.5',
  cy: '11.5',
  r: '4.5',
  key: 'ljjp2s'
}], ['line', {
  x1: '5.5',
  y1: '16',
  x2: '18.5',
  y2: '16',
  key: '1ik3nu'
}]]);
export default Voicemail;